import { Injectable, Injector } from '@angular/core';
import { environment } from '@env/environment';
import { BitfTryCatch } from '@bitf/core/decorators/bitf-try-catch.decorator';
import { IBitfApiRequest } from '@web/interfaces';
import { BitfAdfsService } from '@common/libs/bitforce/core/services/auth/adfs/bitf-adfs.service';
import { StorageService } from '@web/core/services';

@Injectable({
  providedIn: 'root',
})
export abstract class AdfsService extends BitfAdfsService {
  protected storageService: StorageService;

  constructor(protected injector: Injector) {
    super(injector);
    this.storageService = injector.get(StorageService);
  }

  @BitfTryCatch()
  generateToken(code: string) {
    const body = new URLSearchParams();
    body.set('client_id', environment['clientId']);
    body.set('grant_type', 'authorization_code');
    body.set('redirect_uri', environment['adfsRedirectUri']);
    body.set('code', code);
    return this.request({
      headers: [{ headerName: 'Content-Type', value: 'application/x-www-form-urlencoded' }],
      method: 'POST',
      path: '/oauth2/token',
      apiUrl: this.storageService.data.baseAdfsUrl,
      body: body.toString(),
      isBodyRaw: true,
    } as IBitfApiRequest);
  }
}
